module.exports = __webpack_public_path__ + "/images/Onedrive_File.png";